import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useBackgroundContext } from '../../contexts/BackgroundContext';

interface ChampagneConfig {
  size: number;
  speed: number;
  v: number;
  alpha: number;
  left: number;
  top: number;
}

const configs: ChampagneConfig[] = [];
for (let i = 0; i < 50; i++) {
  const v = (Math.floor(Math.random() * 4)) + 1;
  configs.push({
    size: (Math.floor(Math.random() * 7)) + 2,
    speed: 3,
    v,
    alpha: (Math.floor(Math.random() * .5)) + .5,
    left: Math.floor(Math.random() * (580 - (v * 2) + v)) + 20,
    top: Math.floor(Math.random() * (580 - (v * 2) + v)) + 20,
  });
}

const ChampagneBubbles = () => {
  const backgroundContext = useBackgroundContext();

  const bubblesSvg = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   width="600px"
   height="600px"
   viewBox="0 0 600 600"
   version="1.1"
   xmlns="http://www.w3.org/2000/svg">
  <g>
    ${
    configs.map((config) => `<circle
       style="fill:none;stroke:${backgroundContext.colors.secondary};stroke-width:1;stroke-dasharray:none"
       cx="${config.left}"
       cy="${config.top}"
       opacity="${config.alpha}"
       r="${config.size}" />
    />`)
    }
  </g>
</svg>`;

  return <Container>
    <Champagne $bubblesSvg={bubblesSvg}/>
  </Container>
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(var(--shine-bg-color) 30%, #222);
  background: linear-gradient(var(--shine-bg-color) 30%, color-mix(in hsl, var(--shine-bg-color) 50%, #000));
  overflow: hidden;
`;

const Snow = keyframes`
  to {
    transform: translateY(-600px);
  }
`;

const Champagne = styled.div<{ $bubblesSvg: string }>`
  &, &:before, &:after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: -600px;
    right: 0;
    background-image: url('data:image/svg+xml;base64,${({$bubblesSvg}) => window.btoa($bubblesSvg)}');
    background-size: 600px 600px;
    animation: ${Snow} 3s linear infinite;
    content: "";
  }


  &:after {
    //margin-left: -$w/3 + px;
    margin-left: -200px;
    opacity: .4;
    //animation-duration: $s*2;
    animation-duration: 6s;
    animation-direction: reverse;
    filter: blur(3px);
  }

  &:before {
    //animation-duration: $s*3;
    animation-duration: 9s;
    animation-direction: reverse;
    //margin-left: -$w/2 + px;
    margin-left: -300px;
    opacity: .65;
    filter: blur(1.5px);
  }
`;

export default ChampagneBubbles;

